<template>
    <div>
        <b-modal size="xl" scrollable centered title="Preview Surat" :ok-only="true" :lazy="true"
            v-model="ShowPreviewLetter">
            <template v-if="PDFBlob">
                <object :data="PDFBlob" type="application/pdf" width="100%" height="500">
                    <p>
                        It appears you don't have a PDF plugin for this browser.
                        You can
                        <a :href="PDFBlob">
                            click here to
                            download the PDF file.
                        </a>
                    </p>
                </object>
            </template>
        </b-modal>

        <b-row>
            <template v-if="ListOfLetters.length > 0">
                <b-col cols="12" class="mb-1" v-for="(Letter, IndexLetter) in ListOfLetters" :key="IndexLetter">
                    <div class="mb-1 d-flex align-items-center justify-content-start">
                        <div class="mr-1">{{ Letter.NamaSurat }}</div>
                        <div class="d-flex align-items-center">
                            <button type="button" class="btn btn-link mr-1 m-0 p-0"
                                @click="DownloadLetter(Letter.PDFBase64)">
                                <font-awesome-icon class="align-middle"
                                    style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="download" />
                            </button>
                            <button type="button" class="btn btn-link ml-1 m-0 p-0"
                                @click="PreviewLetter(Letter.PDFBase64)">
                                <font-awesome-icon class="align-middle"
                                    style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="eye" />
                            </button>
                        </div>
                    </div>
                </b-col>
            </template>
            <template v-else-if="propSuratRujukBpjs"></template>
            <template v-else>
                <b-col cols="12">
                    <span>-</span>
                </b-col>
            </template>
            <b-col cols="12" class="mb-1" v-if="propSuratRujukBpjs">
                <div class="mb-1 d-flex align-items-center justify-content-start">
                    <div class="mr-1">Surat Rujukan BPJS</div>
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-link mr-1 m-0 p-0"
                            @click="DownloadSuratRujukBpjs()">
                            <font-awesome-icon class="align-middle"
                                style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="download" />
                        </button>
                        <button type="button" class="btn btn-link ml-1 m-0 p-0"
                            @click="PreviewSuratRujukBpjs()">
                            <font-awesome-icon class="align-middle"
                                style="color:#3b3e66;padding:5px;font-size:1.7em;" icon="eye" />
                        </button>
                    </div>
                </div>
            </b-col>
        </b-row>
        </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex';
import { LetterMap } from './Helpers/LetterMap'
import { ParseJenisKelaminSurat } from './Helpers/ParseJenisKelaminSurat';

export default {
    name: 'SuratPenunjangRiwayatRekamMedis',
    props: ['TransKlinikID', 'propSuratRujukBpjs'],
    data() {
        return {
            ListOfLetters: [],
            ShowPreviewLetter: false,
            PDFBlob: null,
            SuratRujukBpjsBlob: null
        }
    },
    watch: {
        TransKlinikID: {
            handler: async function (val) {
                if (val) {
                    this.$nextTick(async () => {
                        await this.GetListOfLetter()
                    })
                }
            },
            immediate: true
        },
        propSuratRujukBpjs: {
            handler: async function (val) {
                if (val) {
                    this.$nextTick(async () => {
                        await this.GetSuratRujukBPJS()
                    })
                }
            },
            immediate: true
        },
        ShowPreviewLetter: {
            handler: function (val) {
                if (!val) {
                    this.$nextTick(() => {
                        URL.revokeObjectURL(this.PDFBlob);

                        this.PDFBlob = null
                    })

                }
            }
        }
    },
    computed: {
        ...mapGetters('SuratPenunjangStore', ['API_URL']),
        DaftarSuratEndpoint() {
            return `${this.API_URL}/daftar-surat`
        }
    },
    beforeDestroy() {
        this.$nextTick(() => {
            this.ResetSuratPenunjangStore();
        })
    },
    methods: {
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        async GetListOfLetter() {
            const { data } = await axios.get(`${this.DaftarSuratEndpoint}/${this.TransKlinikID}`);

            if (data.length > 0) {
                this.ListOfLetters = data.map(item => {
                    return {
                        SuratID: item.id,
                        NamaPasien: item.nama_pasien.trim(),
                        UmurPasien: item.umur_pasien,
                        JenisKelamin: ParseJenisKelaminSurat(item.jenis_kelamin_pasien),
                        NamaSurat: LetterMap(item.table_name),
                        PDFBase64: item.pdf_base64
                    }
                })
            } else {
                this.ListOfLetters = []
            }

            return true
        },
        async GetSuratRujukBPJS() {
            try {
                const res = await axios.post(
                    `${this.url_api}/bpjs/surat_rujuk_blob`, {link: this.propSuratRujukBpjs.link, name: this.propSuratRujukBpjs.name}, {responseType: 'blob'}
                );
                const blob = new Blob(
                    [res.data], 
                    { type: 'application/pdf' }
                );

                this.SuratRujukBpjsBlob = blob;
            } catch (error) {
                // console.log(error);
            }
        },
        async PreviewSuratRujukBpjs() {
            this.ShowPreviewLetter = !this.ShowPreviewLetter

            const PDFBlob = URL.createObjectURL(this.SuratRujukBpjsBlob);

            this.PDFBlob = PDFBlob
        },
        async DownloadSuratRujukBpjs() {
            this.$nextTick(async () => {
                const PDFBlob = URL.createObjectURL(this.SuratRujukBpjsBlob);

                const link = document.createElement('a');
                link.href = PDFBlob;
                link.download = this.propSuratRujukBpjs.name;
                link.click();
            })
        },
        async PreviewLetter(PDFBase64) {
            this.ShowPreviewLetter = !this.ShowPreviewLetter

            const TmpPDFBlob = await fetch(PDFBase64).then(res => res.blob());

            const PDFBlob = URL.createObjectURL(TmpPDFBlob);

            this.PDFBlob = PDFBlob
        },
        async DownloadLetter(PDFBase64) {
            this.$nextTick(async () => {
                const TmpPDFBlob = await fetch(PDFBase64).then(res => res.blob());

                const PDFBlob = URL.createObjectURL(TmpPDFBlob);

                const link = document.createElement('a');
                link.href = PDFBlob;
                link.download = 'download.pdf';
                link.click();
            })
        }
    }
}
</script>